// extracted by mini-css-extract-plugin
module.exports = {"root":"RNy68K","text":"_3j2JkQ"};